import React, { Suspense } from 'react';
import { withAuthenticator } from '@aws-amplify/ui-react';
import { FullWidthSpinner } from '../loader-components';

import '@aws-amplify/ui-react/styles.css';

const LazyMainApp = React.lazy(() => import('./MainApp'));

function LazyMainAppWithAuthenticator() {
    const MainAppWithAuthenticator = withAuthenticator(LazyMainApp);
    return (
        <Suspense fallback={<FullWidthSpinner text='Loading...' scale={3}/>}>
            <MainAppWithAuthenticator />
        </Suspense>
    );
}

export default LazyMainAppWithAuthenticator;
